import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { GroupUserRole } from 'APP/model/group/groupModel.types';
import Entities from 'STORE';

import { GroupsEvent } from '../GroupsEvent';

export class LeaveGroup extends GroupsEvent {
  process() {
    const groupId = this.eventPayload.groupId.toString();
    const group = Entities.GroupsStore.getGroupById(groupId);

    if (!group) {
      return;
    }

    const call = Entities.Calls.ongoingCall;

    if (call && call.groupId === groupId) {
      Tasks.feedback.checkStarsFeedback(call.channelId);
      Entities.Calls.delete(call.groupId, call.channelId);
    }

    if ((group.isChatGroup || group.isChannel) && group.isOpen) {
      group.setUserGroupRole(GroupUserRole.Guest);
      Tasks.group.loadGroupsByIds([groupId], false, true);
      return;
    }

    let alert = t('common_chat_is_not_accessible');
    if (group.isChannel) {
      alert = t('common_channel_is_not_accessible');
    }

    Tasks.group.removeGroupLocally({ groupId: groupId, alert });
  }
}
